var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resolution py-80px"},[_c('div',{staticClass:"block-content"},[_c('block-title',{attrs:{"en":_vm.resolution.title.en,"title":_vm.resolution.title.value,"sub":_vm.resolution.title.sub}}),_vm._v(" "),_c('introduce-timeline',{staticClass:"mt-80px",attrs:{"list":_vm.resolution.list}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }